// Stub para React Native Web — Play Install Referrer é Android-only (Google Play).
// Resolve o callback com erro para não travar a promise em getPlayInstallReferrer().

export const PlayInstallReferrer = {
  getInstallReferrerInfo: (
    callback: (info: any, error: {message: string} | null) => void,
  ) => {
    callback(null, {message: 'Not available on web'});
  },
};

export interface PlayInstallReferrerInfo {
  installReferrer: string;
  referrerClickTimestampSeconds: number;
  installBeginTimestampSeconds: number;
  referrerClickTimestampServerSeconds: number;
  installBeginTimestampServerSeconds: number;
  installVersion: string;
  googlePlayInstantParam: boolean;
}
